import styled from 'styled-components';

interface SpeechBubbleProps {
  desc: string;
}
const CenterBubble = ({ desc }: SpeechBubbleProps) => {
  return (
    <BubbleBox>
      <BubbleDesc>{desc}</BubbleDesc>
    </BubbleBox>
  );
};

export default CenterBubble;

const BubbleBox = styled.div`
  position: relative;
  z-index: 2;
  border-radius: 20px;
  padding: 16px 20px;
  width: calc(175px - 40px);
  min-height: calc(50px - 32px);
  background: #d9d9d9;
  overflow: visible;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #000000;

  /* 삼각형 내부 */
  &::after {
    content: '';
    position: absolute;
    top: -20px; /* ⭐ 위로 */
    left: 50%;
    transform: translateX(-50%);
    z-index: -1;

    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 20px solid #d9d9d9; /* ⭐ 방향 변경 */
  }

  /* 삼각형 border */
  &::before {
    content: '';
    position: absolute;
    top: -22px; /* ⭐ 위로 */
    left: 50%;
    transform: translateX(-50%);
    z-index: -2;

    width: 0;
    height: 0;
    border-left: 11px solid transparent;
    border-right: 11px solid transparent;
    border-bottom: 22px solid #000000; /* ⭐ 방향 변경 */
  }
`;

const BubbleDesc = styled.div`
  color: #000000;
  white-space: pre-wrap;
  word-wrap: break-word;
  text-align: start;
  font-size: 15px;
`;
